export default __webpack_public_path__ + "static/media/2_1.1b2fff3e.png";